var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100X80(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 81,
    viewBox: "0 0 100 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2097_2654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2663 43.9743C55.0023 44.4524 54.9317 45.0035 55.0674 45.5264C55.2888 46.0428 55.6282 46.5077 56.062 46.8886L56.395 48.8126L60.9097 48.9986L59.0502 42.5312L55.2663 43.9743Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1953 31.9877C52.1953 31.9877 54.0764 43.4268 54.3575 44.1139C54.6386 44.8011 56.8051 45.6095 57.5619 45.2578C58.3187 44.9062 56.9954 43.2368 56.9954 43.2368L57.3716 32.2383C57.3716 32.2383 54.1716 31.0985 52.1953 31.9877Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4694 35.5885C57.4694 35.5885 54.8315 35.4147 54.7364 35.8553C54.6412 36.2959 54.6456 37.7874 55.1169 37.9652C55.5883 38.1431 58.7883 38.4058 59.3505 38.228C59.5388 38.1387 59.7058 38.0148 59.8416 37.8637C59.9774 37.7127 60.0793 37.5376 60.1411 37.3489C60.2028 37.1603 60.2232 36.9619 60.2011 36.7657C60.1789 36.5694 60.1147 36.3794 60.0122 36.2069C59.4457 35.4147 57.4694 35.5885 57.4694 35.5885Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4659 38.3987C57.4659 38.3987 54.9231 38.3987 55.0182 38.9242C55.1134 39.4497 54.828 40.5976 55.8831 40.7755C57.1349 40.9208 58.403 40.8909 59.6453 40.6865C59.8568 40.6498 60.0524 40.5566 60.2083 40.4181C60.3642 40.2795 60.4737 40.1017 60.5236 39.9062C60.5735 39.7106 60.5616 39.5057 60.4894 39.3163C60.4172 39.127 60.2877 38.9613 60.1167 38.8393C59.347 38.2209 57.4659 38.3987 57.4659 38.3987Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3976 39.0775C53.3976 39.0775 53.0733 36.8625 52.3079 36.9231C51.7371 36.9676 50.3749 37.3718 50.5003 38.3459C50.7155 39.5088 51.1179 40.6345 51.6938 41.6847C51.7934 41.863 51.9462 42.0105 52.1337 42.1092C52.3212 42.208 52.5353 42.2537 52.7501 42.2409C52.9649 42.228 53.1711 42.1572 53.3436 42.0369C53.5161 41.9166 53.6476 41.7521 53.722 41.5634C54.1328 40.7105 53.3976 39.0775 53.3976 39.0775Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6149 40.7793C57.6149 40.7793 55.3143 40.7792 55.4008 41.2885C55.4873 41.7978 55.2278 42.9054 56.1662 43.0671C57.2999 43.2057 58.4498 43.177 59.5739 42.9822C59.7709 42.9375 59.9506 42.8422 60.0929 42.7073C60.2352 42.5723 60.3344 42.4029 60.3793 42.2181C60.4243 42.0333 60.4132 41.8405 60.3473 41.6613C60.2814 41.4821 60.1633 41.3236 60.0063 41.2037C59.3187 40.6135 57.6149 40.7793 57.6149 40.7793Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7357 42.7071C57.7357 42.7071 55.8114 42.7071 55.8849 43.1113C55.9584 43.5155 55.7422 44.4573 56.5249 44.5988C57.4726 44.7183 58.4348 44.6951 59.3747 44.5301C59.5387 44.4915 59.6879 44.4111 59.8059 44.2978C59.9238 44.1845 60.0057 44.0428 60.0425 43.8885C60.0793 43.7342 60.0695 43.5734 60.0142 43.4241C59.9589 43.2747 59.8602 43.1426 59.7293 43.0426C59.1628 42.5656 57.7357 42.7071 57.7357 42.7071Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6814 20.4023C50.4616 20.4064 49.268 20.7343 48.2399 21.3479C47.2117 21.9614 46.3911 22.8353 45.8736 23.8679C45.3562 24.9004 45.1632 26.0491 45.3171 27.1802C45.471 28.3113 45.9654 29.3782 46.7429 30.2569C47.9235 31.5867 49.8565 32.5406 51.6987 32.4315C57.3464 32.1081 72.1532 39.5213 72.1532 39.5213V13.3125C72.1532 13.3125 57.554 20.5114 51.6814 20.4023Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5311 26.6244C50.531 25.2713 50.9215 23.9432 51.6612 22.7801C52.401 21.6171 53.4627 20.662 54.7344 20.0156C53.7365 20.2551 52.7116 20.3827 51.6814 20.3956C50.4616 20.3997 49.268 20.7276 48.2399 21.3412C47.2117 21.9547 46.3911 22.8286 45.8736 23.8612C45.3562 24.8937 45.1632 26.0424 45.3171 27.1735C45.471 28.3046 45.9654 29.3715 46.7429 30.2502C47.9235 31.58 49.8565 32.5339 51.6987 32.4248C52.3531 32.4009 53.0085 32.4429 53.6533 32.5501C52.6836 31.8506 51.8981 30.9528 51.3569 29.9257C50.8158 28.8986 50.5333 27.7693 50.5311 26.6244Z",
    fill: "#90205D",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7394 29.5204C87.5706 22.4883 82.9563 15.4002 75.4331 13.6886C67.9098 11.9769 60.3265 16.29 58.4953 23.322C56.6642 30.3541 61.2785 37.4422 68.8017 39.1539C76.325 40.8655 83.9083 36.5524 85.7394 29.5204Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0929 26.4182C84.0937 28.6281 83.3935 30.7885 82.0806 32.6263C80.7677 34.4641 78.9013 35.8967 76.7173 36.743C74.5333 37.5892 72.1299 37.811 69.811 37.3804C67.4921 36.9498 65.3619 35.886 63.6899 34.3237C62.0178 32.7614 60.879 30.7707 60.4175 28.6034C59.9559 26.4361 60.1924 24.1895 61.0969 22.1478C62.0015 20.1061 63.5335 18.361 65.4992 17.1331C67.4649 15.9053 69.776 15.25 72.1402 15.25C75.3091 15.2511 78.348 16.4279 80.5892 18.522C82.8304 20.6161 84.0906 23.4562 84.0929 26.4182Z",
    fill: "#A6A6A6",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1392 23.6998V29.1687L62.9455 33.5705C61.545 31.9896 60.6369 30.079 60.3203 28.0479C60.0038 26.0168 60.2911 23.9434 61.1509 22.0547L72.1392 23.6998Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0489 26.4237C75.0489 26.9635 74.8776 27.4912 74.5567 27.9399C74.2357 28.3887 73.7796 28.7384 73.246 28.9448C72.7123 29.1512 72.1252 29.205 71.5589 29.0994C70.9925 28.9938 70.4724 28.7335 70.0644 28.3515C69.6563 27.9696 69.3786 27.483 69.2665 26.9535C69.1544 26.424 69.2128 25.8753 69.4344 25.3768C69.656 24.8783 70.0308 24.4525 70.5114 24.1532C70.992 23.8539 71.5567 23.6945 72.1343 23.6953C72.9077 23.6964 73.649 23.9843 74.1955 24.4959C74.742 25.0074 75.0489 25.7008 75.0489 26.4237Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4514 48.9913L54.9844 47.1602L61.0472 46.4609L60.9131 49.0034L55.4514 48.9913Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.398 37.6077C19.398 37.6077 9.05403 36.5326 8.15455 36.961C7.25508 37.3895 -5.86521 51.8924 -5.86521 51.8924L-13.9259 36.8559L-20.7109 39.6449C-20.7109 39.6449 -12.2091 66.7268 -10.8296 67.034C-9.45015 67.3412 3.64851 59.1964 3.64851 59.1964L2.84417 69.9362C2.84417 69.9362 5.2572 78.9581 15.9472 80.676C26.6371 82.3939 32.9508 74.6614 34.3303 72.0826C35.3573 70.0272 36.24 67.9114 36.9725 65.7486L41.9153 52.1067C41.9153 52.1067 55.8313 62.7252 58.9276 64.0267C62.0238 65.3283 64.8996 66.5005 65.2455 65.8537C65.5915 65.207 62.1449 48.0242 62.1449 48.0242L54.7934 48.3475L55.1394 51.0315C55.1394 51.0315 45.5997 39.3095 44.7954 38.1413C43.991 36.9731 41.578 37.1752 38.7066 36.4234C35.8352 35.6716 19.398 37.6077 19.398 37.6077Z",
    fill: "#90205D",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64844 59.1844L11.3502 53.8125",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57812 55.8499L12.4831 55.2031",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9062 52.0854L44.5485 43.3828",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9375 49.2904L45.8089 45.5312",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4609 57.2812L55.5765 59.4074",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.125 51.0234L55.3326 54.8513",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3062 36.3979L18.2509 37.2589C18.2509 37.2589 16.413 38.6534 15.3795 41.8749C14.7518 43.8429 14.2905 45.854 14 47.8895L18.3677 48.1078L14.9081 51.3415C14.9081 51.3415 15.946 52.736 18.1255 55.7433C19.8477 58.0105 21.7255 60.1708 23.7472 62.2106L17.3471 69.9107C17.3471 69.9107 25.1613 68.2939 29.9874 63.3585C34.8134 58.4232 37.6719 51.006 37.6719 51.006L33.8794 48.2129L37.9011 47.4611C37.9011 47.4611 38.7054 41.3414 34.4415 37.3559C30.1777 33.3704 23.3062 36.3979 23.3062 36.3979Z",
    fill: "#314155",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6731 38.9846C34.6731 38.9846 33.3325 41.4664 33.0644 46.0744C32.8568 49.6718 30.8373 54.2556 29.0557 57.4973C27.6416 60.0761 26.3745 61.8061 26.2837 61.5394C26.2837 61.5394 25.5399 60.4238 24.3507 57.1739C24.061 56.3979 23.7496 55.4924 23.4123 54.4455C21.6825 49.0736 20.1949 40.3751 20.8825 38.6572C21.2052 37.8104 21.5895 36.9852 22.0328 36.1875C27.5508 43.1722 34.6731 38.9846 34.6731 38.9846Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6641 53.6927L29.0565 57.4882C27.6424 60.0671 26.3754 61.7971 26.2846 61.5303C26.2846 61.5303 25.5408 60.4147 24.3516 57.1649L26.2846 53.9029L24.3645 50.544L26.6305 48.4219L29.7311 51.3241L27.6641 53.6927Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8438 52.0915L26.6363 48.4375L31.2547 52.5119",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0312 36.1953C22.1605 38.3592 22.6252 40.4942 23.4107 42.5333C24.2809 44.5925 25.3582 46.5698 26.6281 48.4387L32.038 41.2439C32.038 41.2439 26.1697 41.7815 22.0312 36.1953Z",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4766 24.8129C38.4766 24.8129 40.1198 24.5744 40.1198 26.6722C40.1198 28.7701 39.1685 31.3529 39.1685 31.3529L38.4766 24.8129Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8847 17.0871C37.8847 17.0871 39.035 26.8608 39.1474 29.763C39.2599 32.6652 38.9182 35.24 37.8847 36.5294C36.8512 37.8188 32.6954 42.9725 30.5332 43.1867C28.371 43.4009 25.9363 42.3298 25.0196 41.5699C24.1028 40.81 19.7308 34.371 19.7308 34.371C19.7308 34.371 16.401 34.1567 15.5967 30.0742C14.7923 25.9917 19.2724 26.9618 19.2724 26.9618C19.2724 26.9618 16.8594 23.4169 16.6302 19.9812C16.401 16.5454 15.7091 15.252 25.5947 15.0377C35.4803 14.8235 37.8847 17.0871 37.8847 17.0871Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7419 23.9531L35.5009 32.8659L31.25 31.6856",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9826 30.6094L23.6484 31.2561",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.375 31.1484C25.6947 32.0606 26.2859 32.8686 27.0794 33.4778C27.8729 34.0871 28.8357 34.4723 29.8551 34.5882C33.5308 35.1218 35.3687 34.4791 35.3687 34.4791",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.298 32.8672C26.298 32.8672 26.1855 38.2391 28.2526 38.4533C30.3197 38.6676 29.8613 34.5891 29.8613 34.5891C28.5561 34.2584 27.3413 33.6714 26.298 32.8672Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7109 36.5781C26.992 37.5563 27.4634 38.3688 28.2418 38.4496C28.4376 38.4754 28.6374 38.4515 28.82 38.3804C29.0026 38.3093 29.1613 38.1936 29.2796 38.0454C28.8775 37.3865 27.4893 36.8409 26.7109 36.5781Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.708 26.4268C27.708 27.0209 27.427 27.5019 27.0767 27.5019C26.7264 27.5019 26.4453 27.0209 26.4453 26.4268C26.4453 25.8326 26.7264 25.3516 27.0767 25.3516C27.427 25.3516 27.708 25.8326 27.708 26.4268Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4155 25.4658C35.4155 26.06 35.1301 26.541 34.7798 26.541C34.4295 26.541 34.1484 26.06 34.1484 25.4658C34.1484 24.8716 34.4338 24.3906 34.7798 24.3906C35.1258 24.3906 35.4155 24.8716 35.4155 25.4658Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0312 24.5818C25.5681 24.0115 26.2486 23.5753 27.0112 23.3127C27.7739 23.0502 28.5945 22.9696 29.3989 23.0782",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0703 22.6583C33.0703 22.6583 34.5622 20.0794 36.9623 21.3689",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7172 17.2927C25.7172 17.2927 22.1582 16.7551 22.9625 17.7252C23.7669 18.6953 25.6048 19.8715 24.6923 20.6233C23.7799 21.3751 21.4749 22.6444 21.5917 23.3073C21.7085 23.9702 21.9333 26.6379 21.5917 27.2847C21.2501 27.9314 20.4414 28.0365 19.6371 27.9273C18.8327 27.8182 17.6824 25.8861 17.224 25.3485C16.7656 24.8109 12.6272 20.9467 13.4315 17.8303C14.2359 14.7138 22.8544 12.2441 22.8544 12.2441C22.8544 12.2441 28.3594 6.44778 32.0481 6.33864C35.7369 6.22951 34.3444 9.45508 34.2104 9.7744C34.0763 10.0937 39.4948 9.45508 40.5283 12.5675C41.5619 15.6799 41.2202 16.5408 36.5066 17.7252C31.793 18.9095 25.7172 17.2927 25.7172 17.2927Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.15311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1945 13.0078L88.8278 15.2714L90.7652 16.1768L85.4375 17.6885L96.2529 16.3304L93.5112 15.1218L98.1945 13.0078Z",
    fill: "#90205D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.117 34.3232L90.6427 32.4922L91.9573 34.1009L86.4609 33.2602L96.8093 36.5019L94.9152 34.2869L100.117 34.3232Z",
    fill: "#90205D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9407 48.9216L81.9621 43.8044L82.507 45.7648L77.7891 43L85.9882 49.7381L85.1622 47.0097L89.9407 48.9216Z",
    fill: "#90205D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2097_2654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 80.7339,
    fill: "white",
    transform: "translate(0 0.265625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100X80);
export default __webpack_public_path__ + "static/media/100x80.55f2a5fc.svg";
export { ForwardRef as ReactComponent };